import { render, staticRenderFns } from "./PageLoader.vue?vue&type=template&id=2da553a1&scoped=true&"
import script from "./PageLoader.vue?vue&type=script&lang=js&"
export * from "./PageLoader.vue?vue&type=script&lang=js&"
import style0 from "./PageLoader.vue?vue&type=style&index=0&id=2da553a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da553a1",
  null
  
)

export default component.exports